import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const issueFindingsTableColumns: ITableColumn[] = [
  {
    labelPath: 'issuesPage.relatedFinding.description',
    propertyKey: 'description',
    colType: TableColumnTypeEnum.Text,
    width: 90,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.relatedFinding.type',
    propertyKey: 'type',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.relatedFinding.timestamp',
    propertyKey: 'timestamp',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.relatedFinding.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.relatedFinding.user',
    propertyKey: 'user',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.relatedFinding.tags',
    propertyKey: 'tags',
    colType: TableColumnTypeEnum.Tag,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
];
